import {createSlice} from "@reduxjs/toolkit";
import {
  approveApprovalRequest,
  fetchApprovalRequests,
  rejectApprovalRequest,
} from "../thunks/approvalRequestThunks";

const initialState = {
  items: [],
  pagination: {
    page: 1,
    limit: 10,
    total: 0,
    pages: 0,
  },
  loading: false,
  error: null,
  success: null,
};

const approvalRequestSlice = createSlice({
  name: "approvalRequests",
  initialState,
  reducers: {
    clearApprovalRequestSuccess: (state) => {
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchApprovalRequests.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchApprovalRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload?.data?.approvalRequests || [];
        state.pagination = action.payload?.data?.pagination || initialState.pagination;
      })
      .addCase(fetchApprovalRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(approveApprovalRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(approveApprovalRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload?.message || "Request approved";
      })
      .addCase(approveApprovalRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(rejectApprovalRequest.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(rejectApprovalRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload?.message || "Request rejected";
      })
      .addCase(rejectApprovalRequest.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const approvalRequestAction = approvalRequestSlice.actions;
export default approvalRequestSlice.reducer;
